export enum CameraTypes {
  VDG_RTSP = 'VDG_RTSP',
  VDG_MJPEG = 'VDG_MJPEG',
  WEBSOCKET = 'WEBSOCKET',
  AXXON_MJPEG = 'AXXON_MJPEG',
  HIKVISION_RTSP = 'HIKVISION_RTSP',
  DAHUA_RTSP = 'DAHUA_RTSP',
  WISENET_WAVE_MJPEG = 'WISENET_WAVE_MJPEG',
  AVIGILON_7 = 'AVIGILON_7',
  GENETEC_RTSP = 'GENETEC_RTSP',
  BOSCH_RTSP = 'BOSCH_RTSP',
}
